<template>
  <div id="app"> 
    <div id="content" class="resume">
      <Header />
      <SectionContainer />
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import SectionContainer from "./components/SectionContainer";

require("./assets/js/jquery-1.11.0.min.js");
require("./assets/js/lightbox.min.js");

export default {
  name: "app",
  components: {
    Header,
    SectionContainer
  }
};
</script>

<style>
@import './assets/css/lightbox.css';
@import './assets/css/styles.css';
</style>
